import ExpandableText from "../../../components/common/ExpandableText";

const getColumns = (handleEditCustomField, handleDelete) => [
  {
    label: "Module Name",
    field: "module",
    className: "fw-semibold",
    sortable: true,
  },
  {
    label: "Field Label",
    field: "field_label",
    sortable: true,
  },
  {
    label: "Field Type",
    field: "field_type",
    sortable: false
  },
  {
    label: "Required",
    field: "is_required",
    sortable: true,
    render: (row) => (
      <div>
        {row?.is_required ? "Yes" : "No"}
      </div>
    ),
  },
  {
    label: "Created At",
    field: "created_at",
    className: "fw-semibold",
    sortable: true,
  },
  {
    label: "Action",
    field: "action",
    className: "fw-semibold text-center",
    sortable: false,
    render: (row) => (
      <div className="d-flex gap-2 justify-content-center">
        {/* <div
          className="cursor-pointer"
          // onClick={() => onView(row)}
          title="View Details"
        >
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            visibility
          </span>
        </div> */}
        <div
          className="cursor-pointer"
          onClick={() => handleEditCustomField(row)}
          title="Edit"
        >
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            edit
          </span>
        </div>
        <div
          className="cursor-pointer"
          onClick={() => handleDelete(row.id)}
          title="Delete"
        >
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            delete
          </span>
        </div>
      </div>
    ),
  },
];

export default getColumns;